import React, { useState, useEffect } from "react";
import "../../css/socialmediaicons.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faWhatsapp, faSearchengin,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import { faTimes,faShareAlt,faLocation  } from "@fortawesome/free-solid-svg-icons";
import twitter1 from '../../images/t.jpeg'

const StickySocialIcons = () => {
  const [visible, setVisible] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [closing, setClosing] = useState(false); 

  // 🔹 Show icons after 2 seconds on page load
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 2000);

    return () => clearTimeout(timer); // Cleanup timeout on unmount
  }, []);

  const handleClose = () => {
    setClosing(true); // Start fade-out animation

    setTimeout(() => {
      setVisible(false);
      setMinimized(true);
      setClosing(false); // Reset closing state after hiding
    }, 300); // Match with CSS animation duration
  };

  return (
    <>
        {/* WhatsApp icon (Always visible, outside the container) */}
        <a href="https://wa.me/918838053254" className="whatsapp-icon" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>

      {/* Minimized floating button */}
      {minimized && !visible && (
        <button className="social-toggle-btn" onClick={() => { setVisible(true); setMinimized(false); }}>
          <FontAwesomeIcon icon={faShareAlt} />
        </button>
      )}

      {/* Full social media icons when visible */}
      {visible && (
        <div className={`social-icons-container ${closing ? "fadeOutDown" : "fadeInUp"}`}>
          <button className="close-btn" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <a href="https://facebook.com/24krealtorss" className="icon facebook" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a href=" https://x.com/24K_Realtors" className="icon twitter" target="_blank" rel="noopener noreferrer">
            <img src={twitter1} alt="24krealtors- twitter" />
          </a>
          <a href="https://www.instagram.com/24krealtors/" className="icon instagram" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://www.youtube.com/@24K_Realtors" className="icon Youtube" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
          <a href="https://www.linkedin.com/company/24k-realtors/" className="icon linkedin" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </div>
      )}
      
    </>
  );
};

export default StickySocialIcons;
